import { Grid, type GridProps } from '@mui/material'

export type MolsonGridProps = GridProps & {
  dataTestId?: string
}

export const MolsonGrid = ({
  dataTestId,
  children,
  ...props
}: MolsonGridProps) => {
  return (
    <Grid data-testid={dataTestId} {...props}>
      {children}
    </Grid>
  )
}
